import './Print.scss';
import Component from './Print.js';
export default Component;
